import { MetaAssetChain } from '../interfaces'
import { ChainId } from './chainScan'

export const getChainNameByChainId = (chainId?: ChainId): string | undefined => {
  switch (chainId) {
    case ChainId.BSC_MAINNET:
    case ChainId.BSC_TESTNET:
      return MetaAssetChain.BNB
    case ChainId.ETH_MAINNET:
    case ChainId.ETH_GOERLI:
    case ChainId.ETH_SEPOLIA:
      return MetaAssetChain.ETHEREUM
    case ChainId.MATIC_MAINNET:
    case ChainId.MATIC_TESTNET:
      return MetaAssetChain.POLYGON
    case ChainId.ARBITRUM_MAINNET:
    case ChainId.ARBITRUM_TESTNET:
      return MetaAssetChain.ARBITRUM
    case ChainId.BASE_MAINNET:
    case ChainId.BASE_TESTNET:
      return MetaAssetChain.BASE
    default:
      return undefined
  }
}
